/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAssetsQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  softwareEscrowId: Types.Scalars['ID']['input'];
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  queryFilter?: Types.InputMaybe<Types.Scalars['String']['input']>;
  order?: Types.InputMaybe<Types.QueryOrderEnum>;
  orderBy?: Types.InputMaybe<Types.AssetsOrderByEnum>;
  contentType?: Types.InputMaybe<Types.AssetContentTypeEnum>;
  labeled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  syncStatuses?: Types.InputMaybe<Array<Types.SyncStatusEnum> | Types.SyncStatusEnum>;
  depositStatus?: Types.InputMaybe<Types.DepositStatusEnum>;
}>;

export type IAssetsQuery = {
  __typename?: 'Query';
  assets: {
    __typename?: 'AssetPage';
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    nodesCount: number;
    pagesCount: number;
    nodes: Array<{
      __typename?: 'Asset';
      createdAt: any;
      depositSource?: string | null;
      depositStatus: Types.DepositStatusEnum;
      id: string;
      latestDeposit?: any | null;
      lastUpdateCheck?: any | null;
      syncStatus?: Types.SyncStatusEnum | null;
      type: Types.AssetTypeEnum;
      updatedAt: any;
      error?: string | null;
      size?: any | null;
      contentType?: Types.AssetContentTypeEnum | null;
      integration?:
        | { __typename?: 'CustomIntegration'; id: string; provider: string }
        | { __typename?: 'OauthIntegration'; id: string; provider: string }
        | { __typename?: 'ShareFileIntegration'; id: string; provider: string }
        | null;
      softwareEscrow:
        | {
            __typename?: 'SaasEscrow';
            id: string;
            depositor?: { __typename?: 'Depositor'; companyName?: string | null } | null;
            beneficiary?: { __typename?: 'Beneficiary'; companyName?: string | null } | null;
          }
        | {
            __typename?: 'SoftwareEscrow';
            id: string;
            depositor?: { __typename?: 'Depositor'; companyName?: string | null } | null;
            beneficiary?: { __typename?: 'Beneficiary'; companyName?: string | null } | null;
          };
      policy: { __typename?: 'AssetPolicy'; remove: boolean; update: boolean };
    }>;
  };
};

export const AssetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'assets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'queryFilter' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'QueryOrderEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetsOrderByEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contentType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetContentTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'labeled' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'syncStatuses' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SyncStatusEnum' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'depositStatus' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'DepositStatusEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'perPage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'perPage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'queryFilter' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'queryFilter' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'softwareEscrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contentType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contentType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'labeled' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'labeled' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'syncStatuses' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'syncStatuses' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'depositStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'depositStatus' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'depositStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'integration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'latestDeposit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastUpdateCheck' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'syncStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'softwareEscrow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'depositor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'companyName' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'beneficiary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'companyName' } }],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'policy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'remove' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pagesCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAssetsQuery, IAssetsQueryVariables>;
